import { render, staticRenderFns } from "./MultiIntermediaryHelpList.vue?vue&type=template&id=1b2be16b&"
import script from "./MultiIntermediaryHelpList.vue?vue&type=script&lang=js&"
export * from "./MultiIntermediaryHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports